<template>
  <form method="post" @submit.prevent="onSend">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="user_account"
            attribute="attributes.account"
            :label="$t('attributes.account')"
            custom-class="required"
          >
            <b-input
              v-model="form.user_account"
              name="user_account"
              :placeholder="
                $t('message.please_input') + $t('attributes.account')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="user_password"
            attribute="attributes.password"
            :label="$t('attributes.password')"
            :custom-class="!id ? 'required' : ''"
          >
            <b-input
              v-model="form.user_password"
              name="user_password"
              :placeholder="
                $t('message.please_input') + $t('attributes.password')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="user_email"
            attribute="attributes.email"
            :label="$t('attributes.email')"
            :custom-class="activity.type === 1 ? 'required' : ''"
          >
            <b-input
              v-model="form.user_email"
              type="email"
              name="user_email"
              :placeholder="$t('message.please_input') + $t('attributes.email')"
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="user_name"
            attribute="attributes.user_name"
            :label="$t('attributes.user_name')"
            custom-class="required"
          >
            <b-input
              v-model="form.user_name"
              name="user_name"
              :placeholder="
                $t('message.please_input') + $t('attributes.user_name')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="user_identity"
            attribute="attributes.identity_number"
            :label="$t('attributes.identity_number')"
            :custom-class="activity.type === 1 ? 'required' : ''"
          >
            <b-input
              v-model="form.user_identity"
              name="user_identity"
              :placeholder="
                $t('message.please_input') + $t('attributes.identity_number')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="phone_number"
            attribute="attributes.phone_number"
            :label="$t('attributes.phone_number')"
            :custom-class="activity.type === 1 ? 'required' : ''"
          >
            <b-input
              v-model="form.phone_number"
              name="phone_number"
              :placeholder="
                $t('message.please_input') + $t('attributes.phone_number')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="date_of_birth"
            attribute="attributes.date_of_birth"
            :label="$t('attributes.date_of_birth')"
            :custom-class="activity.type === 1 ? 'required' : ''"
          >
            <b-datepicker
              v-model="form.date_of_birth"
              :date-formatter="formatDate"
              :placeholder="$t('attributes.date_of_birth')"
            >
            </b-datepicker>
          </form-group>

          <form-group
            horizontal
            name="member_role"
            attribute="attributes.member_role"
            :label="$t('attributes.member_role')"
          >
            <b-select v-model="form.member_role" name="member_role" expanded>
              <option value="manager">{{ $t('attributes.manager') }}</option>
              <option value="member">{{ $t('attributes.member') }}</option>
            </b-select>
          </form-group>

          <form-group
            v-show="activity.region_enabled"
            horizontal
            name="region"
            :attribute="activity.region_alias"
            :label="activity.region_alias"
          >
            <b-input
              v-model="form.region"
              name="region"
              :placeholder="$t('message.please_input') + activity.region_alias"
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            v-show="activity.area_enabled"
            horizontal
            name="area"
            :attribute="activity.area_alias"
            :label="activity.area_alias"
          >
            <b-input
              v-model="form.area"
              name="area"
              :placeholder="$t('message.please_input') + activity.area_alias"
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            v-show="activity.department_enabled"
            horizontal
            name="department"
            :attribute="activity.department_alias"
            :label="activity.department_alias"
          >
            <b-input
              v-model="form.department"
              name="department"
              :placeholder="
                $t('message.please_input') + activity.department_alias
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            v-show="activity.section_enabled"
            horizontal
            name="section"
            :attribute="activity.section_alias"
            :label="activity.section_alias"
          >
            <b-input
              v-model="form.section"
              name="section"
              :placeholder="$t('message.please_input') + activity.section_alias"
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="membership"
            :label="$t('attributes.membership')"
            custom-class="required"
          >
            <b-select
              v-model="form.membership"
              name="membership"
              :placeholder="
                $t('message.please_select') + $t('attributes.membership')
              "
              expanded
              @input="resetSubsidy"
            >
              <option v-for="type in membershipList" :key="type" :value="type">
                {{ type }}
              </option>
            </b-select>
          </form-group>

          <form-group
            horizontal
            name="member_status"
            :label="$t('attributes.member_status')"
          >
            <b-input
              v-model="form.member_status"
              name="member_status"
              :placeholder="
                $t('message.please_input') + $t('attributes.member_status')
              "
              expanded
            >
            </b-input>
          </form-group>

          <form-group
            horizontal
            name="free_quota"
            :label="$t('attributes.free_quota')"
            custom-class="required"
          >
            <b-numberinput
              v-model="form.free_quota"
              name="free_quota"
              min="0"
              :placeholder="
                $t('message.please_input') + $t('attributes.free_quota')
              "
              controls-position="compact"
              expanded
            >
            </b-numberinput>
          </form-group>

          <form-group
            horizontal
            name="max_quota"
            :label="$t('attributes.max_quota')"
            custom-class="required"
          >
            <b-numberinput
              v-model="form.max_quota"
              name="max_quota"
              min="1"
              :placeholder="
                $t('message.please_input') + $t('attributes.max_quota')
              "
              controls-position="compact"
              expanded
            >
            </b-numberinput>
          </form-group>

          <form-group name="subsidy">
            <b-field horizontal>
              <template #label>
                {{ $t('attributes.subsidy') }}
                <span style="font-size: 1.25rem; color: red;"> *</span>
                <b-tooltip type="is-dark" label="若要特別設定，請填入數值">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-input
                v-model="form.subsidy"
                name="subsidy"
                min="0"
                placeholder="若要特別設定，請填入數值"
                expanded
              >
              </b-input>
            </b-field>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button :loading="sending" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button :loading="sending" type="is-primary" native-type="submit">
          {{ isEditing ? $t('attributes.update') : $t('attributes.add') }}
        </b-button>
      </footer>

      <b-loading :active.sync="isLoading" :is-full-page="false"></b-loading>
    </div>
  </form>
</template>

<script>
import {
  required,
  requiredIf,
  requiredUnless,
  email,
  alphaNum,
  numeric,
  minLength,
  maxLength,
  minValue
} from 'vuelidate/lib/validators'
import { FIRM_COLLABORATES_ACTIVITIES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ActivityUserForm',

  props: {
    activity: {
      Required: true,
      type: Object
    },
    sending: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: null
    },
    user_account: {
      type: String,
      default: ''
    },
    user_email: {
      type: String,
      default: ''
    },
    user_name: {
      type: String,
      default: ''
    },
    user_identity: {
      type: String,
      default: ''
    },
    phone_number: {
      type: String,
      default: ''
    },
    date_of_birth: {
      type: String,
      default: ''
    },
    member_role: {
      type: String,
      default: 'member'
    },
    membership: {
      type: String,
      default: null
    },
    member_status: {
      type: String,
      default: ''
    },
    region: {
      type: String,
      default: null
    },
    area: {
      type: String,
      default: null
    },
    department: {
      type: String,
      default: null
    },
    section: {
      type: String,
      default: null
    },
    free_quota: {
      type: Number,
      default: 1
    },
    max_quota: {
      type: Number,
      default: 5
    },
    subsidy: {
      type: Number,
      default: null
    }
  },
  data() {
    const date_of_birth =
      this.date_of_birth && new Date(Date.parse(this.date_of_birth))

    return {
      isLoading: false,
      isEditing: this.id !== null,
      subsidies: [],
      membershipList: [],
      form: {
        id: this.id,
        user_account: this.user_account,
        user_password: '',
        user_email: this.user_email,
        user_name: this.user_name,
        user_identity: this.user_identity,
        phone_number: this.phone_number,
        date_of_birth: date_of_birth,
        member_role: this.member_role,
        membership: this.membership,
        member_status: this.member_status || '',
        region: this.region,
        area: this.area,
        department: this.department,
        section: this.section,
        free_quota: this.free_quota - 1,
        max_quota: this.max_quota,
        subsidy: this.subsidy
      }
    }
  },
  validations: {
    form: {
      user_account: {
        required,
        alphaNum,
        maxLength: maxLength(256)
      },
      user_password: {
        required: requiredUnless('id'),
        minLength: minLength(4),
        maxLength: maxLength(64)
      },
      user_email: {
        email,
        requiredIf: requiredIf(function() {
          return this.activity.type === 1
        }),
        maxLength: maxLength(256)
      },
      user_name: { required, maxLength: maxLength(128) },
      user_identity: {
        requiredIf: requiredIf(function() {
          return this.activity.type === 1
        }),
        maxLength: maxLength(20)
      },
      phone_number: {
        requiredIf: requiredIf(function() {
          return this.activity.type === 1
        }),
        maxLength: maxLength(50)
      },
      date_of_birth: {
        requiredIf: requiredIf(function() {
          return this.activity.type === 1
        })
      },
      membership: { required },
      member_status: { maxLength: maxLength(50) },
      region: { maxLength: maxLength(50) },
      area: { maxLength: maxLength(50) },
      free_quota: { required, numeric, minValue: minValue(0) },
      max_quota: { required, numeric, minValue: minValue(1) },
      subsidy: { required, numeric, minValue: minValue(0) }
    }
  },
  computed: {
    formTitle() {
      return (
        this.$t(this.isEditing ? 'attributes.modify' : 'attributes.add') +
        this.$t('attributes.user')
      )
    }
  },
  mounted() {
    this.loadSubsidies()
  },
  methods: {
    resetSubsidy() {
      const subsidies = this.subsidies.filter(
        s => s.membership === this.form.membership
      )

      if (subsidies.length > 0) {
        this.form.subsidy = subsidies[0].subsidy
      } else {
        this.form.subsidy = null
      }
    },
    async loadSubsidies() {
      const api = `${FIRM_COLLABORATES_ACTIVITIES_API}/${this.activity.id}/subsidies`

      this.isLoading = true
      try {
        const res = await this.axios.get(api)
        this.subsidies = res.data.data

        const membershipList = this.subsidies.map(s => s.membership)
        this.membershipList = membershipList.filter(
          (i, idx) => membershipList.indexOf(i) === idx
        )
      } catch (e) {
        this.subsidies = []
        this.membershipList = []

        notifyService.fetch_error('collaborate_subsidy_list', e)
      } finally {
        this.isLoading = false
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const date_of_birth = this.formatDate(this.form.date_of_birth)

      const data = {
        ...this.form,
        date_of_birth,
        free_quota: this.form.free_quota + 1
      }

      this.$emit('onSend', data)
    }
  }
}
</script>
